<template>
  <v-container fluid align-start ma-0 pa-2 class="epms5000-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList"
                  @btnRetrieve="btnRetrieve"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Delivery Division :'" />
                      <v-col cols="2">
                        <v-select
                          v-model="selectedDlv"
                          :items="dlvList"
                          return-object
                          item-text="codeName"
                          item-value="code"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>

                      <i-label :label="'Delivery Plan Date :'" class="pl-2" />
                      <v-col cols="1">
                        <DxDateBox
                          :value="stDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                      <span class="px-2 d-flex align-center text-h6"> ~ </span>
                      <v-col cols="1">
                        <DxDateBox
                          :value="edDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {edDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col class="d-flex justify-end" style="color: #0000ff; font-weight: bold;">
                <span>
                  (Inclueded V.A.T )
                </span>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <DxDataGrid
                  :ref="epms5000Ref"
                  height="365"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  @cellClick="getDetail"
                >
                   <DxFilterRow :visible="true" />
                  <DxPaging :enabled="true" />
                  <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="delyDte" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false"
                                        header-cell-template="pDateTmpl" />
                  <template #pDateTmpl>
                    <div>Delivery<br>Plan Date</div>
                  </template>
                  <DxColumn data-field="whDte" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" 
                                        header-cell-template="wDateTmpl" />
                  <template #wDateTmpl>
                    <div>Warehousing<br>Date</div>
                  </template>
                  <DxColumn data-field="delyNo" caption="Delivery No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNo" caption="POR NO" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="delyQty" caption="Quantity" width="7%" data-type="number" format="#,###" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyAmt" caption="Amount" width="7%" data-type="number" format="#,###" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transFee" caption="Trans. Fee" width="7%" data-type="number" format="#,###" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="govFee" caption="Gov. Fee" width="7%" data-type="number" format="#,###" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyType" caption="Type" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <template #numTmpl="{ data }">
                    {{ getNumComma(data.value) }}
                  </template>
                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList2"
                  @btnViewOrModify="btnViewOrModify"
                  @btnPrintDelivery="btnPrintDelivery"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Delivery Note Detail Information :'" />
                      <v-col cols="1">
                        <v-text-field 
                          class="text-center"
                          dense 
                          outlined 
                          hide-details="auto"
                          readonly
                          height="32"
                          :value="delyNo"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col>
                <DxDataGrid
                  :ref="epms5000Ref2"
                  :data-source="dataList2" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                >                  
                  <DxPaging :enabled="false" />
                  <DxPager :show-info="false" />
                  <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="shipNo" caption="Ship No" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"
                                        cell-template="porNoTmpl" />
                  <template #porNoTmpl="{ data }">
                    {{ `${data.data.porNo}-${data.data.porSeq}` }}
                  </template>
                  <DxColumn data-field="block" caption="Block" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="mact" caption="Activity" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="bomSerno" width="3%" data-type="string" alignment="center" :allow-editing="false"
                                        header-cell-template="serNoTmpl" cell-template="numTmpl" />
                  <template #serNoTmpl>
                    <div>Ser.<br>No</div>
                  </template>
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="uprice" caption="Unit Price" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyQty" caption="Quantity" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyAmt" caption="Amount" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyVat" caption="VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transFee" caption="Trans. Fee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transVat" caption="Trans. VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="govFee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        header-cell-template="govFeeTmpl" cell-template="numTmpl" />
                   <template #govFeeTmpl>
                    <div>Gov. Fee<br>(U/Price)</div>
                  </template>
                  <DxColumn data-field="partUnitWgt" caption="Weight" width="4%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <template #numTmpl="{ data }">
                    {{ getNumComma(data.value) }}
                  </template>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getDateFormat, getFirstDate, getLastDate, getNumComma } from '@/utils/common.js'
import { getEpms5000 } from '@/api/view/hip/5/epms5000'
import { getEpms5010DelyList } from '@/api/view/hip/5/epms5010'
import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms5000',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms5000Ref: 'epms5000Ref',
      epms5000Ref2: 'epms5000Ref2',
      useBtnList: ['btnRetrieve'],
      useBtnList2: ['btnViewOrModify', 'btnPrintDelivery'],
      dataList: [],
      dataList2: [],
      delyNo: null,
      selectedDlv: null,
      dlvList: [],
      stDte: null,
      edDte: null,
      makerCd: this.$store.state.user.makerCd
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms5000Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms5000Ref2)
    }
  },
  methods: {
    async getDlvList() {
      const param = {
        code: '',
        codegr: '',
        prtCode: 'DLV_DIV',
        userFlag: 'Y'
      }

      await getCmChildCode(param).then(res => {
        this.dlvList = res.list
        this.dlvList.unshift({
          code: '',
          codeName: 'All'
        })
        this.selectedDlv = this.dlvList[0]
      })
    },
    init() {
      this.grid2Instance.option('defaultPaging', false)
      this.stDte = getFirstDate('m')
      this.edDte = getLastDate('m')
    },
    btnRetrieve() {
      this.dataList = []
      this.dataList2 = []
      this.openLoading('searching')

      const param = {
        whYn: this.selectedDlv.code,
        makerCd: this.makerCd,
        stDte: this.stDte,
        edDte: this.edDte
      }

      // console.log('getEpms5000Param', param)

      getEpms5000(param).then(res => {
        // console.log('getEpms5000Res', res)

        this.dataList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    async getDetail(e) {
      this.selectedHeader = null
      this.delyNo = null
      // console.log('getDetailE', e)

      if(e.rowIndex > -1 && e.rowType === 'data') {
        this.dataList2 = []
        this.openLoading('searching')
  
        this.selectedHeader = e.row.data
        this.delyNo = this.selectedHeader.delyNo
  
        // console.log('this.selectedHeader', this.selectedHeader)
  
        getEpms5010DelyList(this.selectedHeader).then(res => {
          // console.log('getEpms5010DelyListRes', res)
  
          let data = res.list
  
          for(let i = 0; i < data.length; i++) {
            data[i].rnum = i + 1
          }
  
          this.dataList2 = data
        }).finally(() => {
          this.endLoading()
        })
      }
    },
    btnViewOrModify() {
      this.$router.push({
        name: 'epms5010',
        params: this.selectedHeader
      })
    },
    btnPrintDelivery() {
      if(!this.selectedHeader) {
        return
      }

      let param = {
        as_dely_no: this.delyNo,
        as_maker_cd: this.makerCd
      }
      
      if(this.makerCd === '90263' || this.makerCd === '95987') {
        if(this.selectedHeader.delyType.trim() === 'O') {
          param.fileName = 'epms5080.jrxml'
        } else {
          param.fileName = 'epms9020.jrxml'
        }
      } else {
        if(this.selectedHeader.delyType.trim() === 'O') {
          param.fileName = 'epms5080.jrxml'
        } else {
          param.fileName = 'epms5010.jrxml'
        }
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    getNumComma(val) {
      return getNumComma(val)
    }
  },
  async mounted() {
    await this.getDlvList()
    this.init()
    this.btnRetrieve()
  }
}
</script>

<style lang="scss" scoped>
.epms5000-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }
}
</style>